import ReceiptBreakdownReport from './ReceiptBreakdownReport';

export default function ReceiptsTenantsReport() {
  return <ReceiptBreakdownReport type="INQUILINO" />;
}
